import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Close16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.00006 6.93933L3.53039 2.46967L2.46973 3.53033L6.9394 8L2.46973 12.4697L3.53039 13.5303L8.00006 9.06066L12.4697 13.5303L13.5304 12.4697L9.06072 8L13.5304 3.53033L12.4697 2.46967L8.00006 6.93933Z'
      fill='currentColor'
    />
  </Svg>
);

Close16.displayName = 'Close16';
export default Close16;
